import TimeAgo from 'javascript-time-ago'

import { DAY_MONTH_YEAR, HOUR_MINUTE_AM_PM } from '@/constants/constants'
import { useAuth } from '@/hooks'

const getDayMonthYear = (datetime: Date) => {
  return new Date(datetime).toLocaleDateString('en-GB', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

const getMonthDayYear = (datetime: Date) => {
  const date = new Date(datetime)
  const dateStr = date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  return `${dateStr}`
}

const get12HourTime = (datetime: Date) => {
  return new Date(datetime).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  })
}

const get24HourTime = (datetime: Date) => {
  return new Date(datetime).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}

export const formatDate = (datetime: string | number | Date) => {
  const user = useAuth()
  const dateFormat = user.dateFormat === DAY_MONTH_YEAR
  const timeFormat = user.timeFormat === HOUR_MINUTE_AM_PM

  const timeStr = timeFormat
    ? get12HourTime(new Date(datetime))
    : get24HourTime(new Date(datetime))

  if (dateFormat) {
    return `${getDayMonthYear(new Date(datetime))}, ${timeStr}`
  }

  return `${getMonthDayYear(new Date(datetime))}, ${timeStr}`
}

export const timeAgo = (datetime: string | number): string => {
  const timeAgo = new TimeAgo('en-US')
  const date = new Date(datetime)

  return timeAgo.format(date) as string
}
